import React from "react";
import "./Slider.css";
import { useInView } from "react-intersection-observer";
const Slider = ({ imageSrc, title, subtitle, flipped }) => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.4,
  });
  const renderContent = () => {
    if (!flipped) {
      return (
        <>
          {/* slider resmi */}
          <img src={imageSrc} alt="eLogo" className="slider__image" />
          {/* slider başlığı */}
          <div className="slider__content">
            {/* slider açıklaması */}
            <h1 className="slider__title">{title}</h1>
            <p>{subtitle}</p>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="slider__content">
            <h1 className="slider__title">{title}</h1>
            <p>{subtitle}</p>
          </div>
          <img src={imageSrc} alt="eLogo" className="slider__image" />
        </>
      );
    }
  };
  return (
    <div className={inView ? "slider slider--zoom" : "slider"} ref={ref}>
      {renderContent()}
    </div>
  );
};

export default Slider;
